<app-header></app-header>

@if (masked) {
<div id="app_backdrop"
     class="mask-screen"
     (click)="onMaskClick()"
     [ngClass]="{'hiding': hidingMask}">
</div>
}

<div appDropdownEvent
     style="min-height: 81vh;">
    <router-outlet appUnloadBrowserNotification></router-outlet>
</div>

<app-footer></app-footer>